import React from 'react';
import PageGenerator from 'components/generator-shared';
import PostGenerator from 'components/generator-post';
import Loading from 'shared/loading';
import ArticleCard from 'shared/article-card';
// import AsideTabs from 'shared/aside-tabs';
// import CustomAsidesGenerator from 'components/generator-custom-asides';
import AsideCategories from 'components/templates-aside/aside-categories';
import AsideTopInflReq from 'components/templates-aside/aside-top-infls-req';
import AsideSuggestInfl from 'components/templates-aside/aside-suggest-infl';
import useWordpress from 'hooks/useWordpress';
import Headline from 'headline';
import Container from 'shared/container';
import { Link } from 'gatsby';
import Meta from 'shared/meta';
import { useCategoryColor } from '@/hooks/useCategoryColor';

import 'styles/main.scss';

export default function PageTemplate({ pageContext }) {
  const context = process.env.GATSBY_DEVELOPMENT
    ? useWordpress(pageContext)
    : pageContext;
  const mainCategory = pageContext.post_fields.categories[0];
  const { sanitizedCategory } = useCategoryColor(mainCategory);
  return context ? (
    <main>
      <Meta {...context?.meta} />
      <Container>
        <div className="post">
          <div className="post__container">
            <Link to={sanitizedCategory}>
              <Headline title h2 html={mainCategory} />
            </Link>
            {context.post_fields && (
              <ArticleCard {...context.post_fields} fixslug main noExcerpt fullImage invert />
            )}
            <div className="post__wrapper">
              <PostGenerator {...context} />
            </div>
          </div>
          <div className="post__asides">
            <AsideSuggestInfl />
            <AsideTopInflReq top3Infl={pageContext.top3Infl} />
            <div className="post__sticky">
              <AsideCategories />
            </div>
            {/* {!custom_asides && asideProps && asideProps.defaultAsideProps && (
              <AsideTabs tabs={asideProps.defaultAsideProps} />
            )}
            {custom_asides && <CustomAsidesGenerator {...{ asides_list }} />} */}
          </div>
        </div>
      </Container>
      <PageGenerator {...context} />
    </main>
  ) : (
    <Loading />
  );
}
